import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { TaskCheckpointsRepository } from './repositories/task-checkpoints.repository';
import { TaskTypesRepository } from './repositories/task-types.repository';
import { TaskRepository } from './repositories/task.repository';
import { workflowRoutes } from './workflow.routes';
import { SOFTLINE_CONFIG_WORKFLOW_TYPE, WorkflowTypeConfig } from './workflow.shared';

export const provideWorkflowMonitorModule: () => Array<
  Provider | EnvironmentProviders
> = () => [
  provideSoftAppsModule(
    {
      name: 'workflows',
      title: 'Workflows',
      icon: 'fa-regular fa-arrow-progress',
      color: 'bg-warning text-black',
      route: '/workflow/overview',
      permission: 'SOFTAPPS.TASK_WORKFLOW',
      group: getModuleGroupByName('Gewerbe'),
    },
    withSoftAppsModuleRoutes({ app: workflowRoutes }),
    withSoftAppsModuleTranslation({
      de: de,
    }),
    withSoftAppsModuleInfo({
      library: '@softapps/gewerbe/workflow',
      description: 'Workflows anzeigen und Schritte bearbeiten.',
    })
  ),
  {
    provide: SOFTLINE_CONFIG_WORKFLOW_TYPE,
    useValue: {
      type: 'TASK',
      getRoute: (workflow) => ['/workflow/task', String(workflow.type.id)],
      getSummary: () =>
        import('./pages/task-workflow/task-workflow.summary').then(
          (m) => m.getTaskWorkflowSummary
        ),
      getSummaryProviders: () => [
        TaskRepository,
        TaskCheckpointsRepository,
        TaskTypesRepository,
      ],
      viewModes: ['kanban', 'table'],
    } satisfies WorkflowTypeConfig,
    multi: true,
  },
];
